import axios from "axios";
import Cookies from "js-cookie";
import {
  genericErrorHandler,
  genericSuccessHandler,
  standardHeaders,
} from "./axios-base";

export const axiosInstanceOptionalAuth = axios.create({
  headers: { ...standardHeaders },
});

axiosInstanceOptionalAuth.interceptors.request.use((config) => {
  const authJWT: string =
    Cookies.get("session_token") || Cookies.get("port_key_j");
  if (authJWT) {
    config.headers.Authorization = `Bearer ${authJWT}`;
  }
  return config;
}, genericErrorHandler);

axiosInstanceOptionalAuth.interceptors.response.use(
  genericSuccessHandler,
  genericErrorHandler
);

export const axiosInstanceNoAuth = axios.create({
  headers: { ...standardHeaders },
});

axiosInstanceNoAuth.interceptors.request.use((c) => c, genericErrorHandler);
axiosInstanceNoAuth.interceptors.response.use(
  genericSuccessHandler,
  genericErrorHandler
);

/**
 * N.b. only use this instance / functions for validated endpoints
 */
const axiosInstance = axios.create({
  headers: { ...standardHeaders },
});

axiosInstance.interceptors.response.use(
  genericSuccessHandler,
  genericErrorHandler
);

export default axiosInstance;
